module.exports = __webpack_public_path__ + "static/media/icon_cancel.91490244.svg";